import React from 'react';

import dynamic from '@/utils/dynamic';

import { QuizEditorSidebarTabs } from '../../types';
import { TabDetailsProps } from './types';

const QuestionsList = dynamic(
  () =>
    import(
      /* webpackChunkName: "quiz-builder-questions" */ '@/modules/corporate/modules/quiz/views/QuizEditor/components/QuizEditorSidebar/views/QuestionsList'
    ),
);

const Design = dynamic(
  () =>
    import(
      /* webpackChunkName: "quiz-builder-design" */ '@/modules/corporate/modules/quiz/views/QuizEditor/components/QuizEditorSidebar/views/Design'
    ),
);

const QuizSettings = dynamic(
  () =>
    import(
      /* webpackChunkName: "quiz-builder-settings" */ '@/modules/corporate/modules/quiz/views/QuizEditor/components/QuizEditorSidebar/views/QuizSettings'
    ),
);

const TabDetails: React.FC<TabDetailsProps> = (props) => {
  const { activeTab } = props;

  switch (activeTab) {
    case QuizEditorSidebarTabs.Question: {
      return <QuestionsList />;
    }
    case QuizEditorSidebarTabs.Design: {
      return <Design />;
    }
    case QuizEditorSidebarTabs.Settings: {
      return <QuizSettings />;
    }
    default:
      return null;
  }
};

export default React.memo(TabDetails);
